import gql from 'graphql-tag';

export default gql`
  mutation invitationSetStores($input: InvitationStoresInput!) {
    invitationSetStores(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
